<template>
    <div id="app">
        <Menu v-show="menuOpen" v-if="isLogin"></Menu>
        <!-- <transition name="fade"> -->
        <router-view/>
        <!-- </transition> -->

        <FullLoading v-show="isLoading" />
        <v-dialog />
        <!-- <modal name="dialog" :width="800" /> -->
    </div>
</template>

<script>
import FullLoading from '@/components/FullLoading'
import Menu from '@/components/Menu'
import mainDelegate from '@/delegate/mainDelegate'
import soundDelegate from '@/delegate/soundDelegate'
import examDelegate from '@/delegate/examDelegate'
import myNoteDelegate from '@/delegate/myNoteDelegate'
import todayDelegate from '@/delegate/todayDelegate'
import loginController from '@/controller/loginController'
import examController from '@/controller/examController'
import vocabularySoundConrtoller from '@/controller/vocabularySoundConrtoller'
import myNoteController from '@/controller/myNoteController'
import todayStepController from '@/controller/todayStepController'
import goAnWordController from '@/controller/goAnWordController'
import lessonExamListControlle from '@/controller/lessonExamListControlle'
export default {
    name: 'App',
    mixins: [
        soundDelegate,
        mainDelegate,
        examDelegate,
        myNoteDelegate,
        todayDelegate,
        loginController,
        examController,
        vocabularySoundConrtoller,
        myNoteController,
        todayStepController,
        goAnWordController,
        lessonExamListControlle
    ],
    components: {
        FullLoading,
        Menu
    },
    created() {
        document.body.removeChild(document.getElementById('init-loading'))
    }
}
</script>

<style lang="less">
@import 'global.less';
@import 'vue-transition.less';
* {
    box-sizing: border-box;
    margin: 0px;
    padding: 0px;
}
#app {
    font-family: 'PingFangTC', Arial, 'WenQuanYi Zen Hei', '儷黑 Pro',
        'LiHei Pro', '微軟正黑體', 'Microsoft JhengHei', '標楷體', DFKai-SB,
        sans-serif;
    font-weight: 500;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    user-select: none;
}
input,
textarea,
select {
    &:focus {
        outline: none;
    }
}
@media only screen and (min-width: @rwd) {
    body {
        background-image: url('./assets/img/bg.png');
        background-repeat: repeat;
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue